import { render, staticRenderFns } from "./SudentAudit.vue?vue&type=template&id=f764f2e0"
import script from "./SudentAudit.vue?vue&type=script&lang=js"
export * from "./SudentAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports